<template>
  <div class="componentBox">
    <h2 class="componentTitle">饲养信息</h2>
    <h3 class="littleTitle">饲养信息</h3>
    <Cell :colList="feedInfoCell" :detail="feedDetail" />
    <a-table class="tableBox2" :columns="feedInfoRuminateColumns" :data-source="feedList" :pagination="false">
      <template slot="weight" slot-scope="t">
        {{ t?.toFixed(2) }}
      </template>
      <template slot="num" slot-scope="t">
        {{ t?.toFixed(2) }}
      </template>
    </a-table>
    <Cell :colList="feedStageCell" :detail="feedDetail" :len="2"/>
    <h3 class="littleTitle">平均日饲喂情况</h3>
    <a-table class="tableBox2" :columns="feedingRuminateSituation" :data-source="ruminationLineRaiseInfos" :pagination="false">
      <template slot="weight" slot-scope="t">
        {{ t?.toFixed(2) }}
      </template>
      <template slot="price" slot-scope="t">
        {{ t?.toFixed(2) }}
      </template>
      <template slot="dryPercentage" slot-scope="t">
        {{ t?.toFixed(2) }}
      </template>
    </a-table>
    <h3 class="littleTitle">采食及耗料</h3>
    <Cell :colList="feedCell" :detail="ruminationLineProductResult" :len="2"/>
    <h3 class="littleTitle">生产结果</h3>
    <Cell :colList="productionResultsCell" :detail="ruminationLineProductResult" :len="2"/>
    <h3 class="littleTitle">经济效益</h3>
    <Cell :colList="economicBenefits" :detail="ruminationLineProductResult" :len="2"/>
  </div>
</template>

<script>
import Cell from './Cell.vue';
import {feedInfoRuminateColumns,feedingRuminateSituation} from '../Columns'
export default {
  components: {Cell},
  props: ['detail'],
  data() {
    return {
      feedInfoRuminateColumns,
      feedingRuminateSituation,
      feedInfoCell: [
        {title: '畜种类型',field: 'animalType',},
        {title: '饲养品种',field: 'feedVariety',},
        {title: '饲养阶段',field: 'feedStage',},
        {title: '性别',field: 'sex',},
        {title: '饲养模式',field: 'feedStyle',},
        {title: '饲料品牌',field: 'feedBrand',},
        {title: '饲料型号',field: 'feedModel',},
        {title: 'NHModel名称',field: 'modelName',},
        {title: 'NHModel代码',field: 'modelCode',},
        {title: '产品定位',field: 'feedTarget',},
        {title: '饲料终端价格(元/吨)',field: 'feedTerminalPrice',},
        {title: '腹泻比例（%）',field: 'proportionDiarrhea',},
      ],
      feedStageCell: [
        {title: '购进成本(元/头)',field: 'bugPrice',},
        {title: '出售单价(元/kg)',field: 'salePrice',},
      ],
      feedCell: [
        {title: '均采食量(kg/天)',field: 'avgFeedCost',},
        {title: '均干物质采食量(kg/天)',field: 'avgDryFeedCost',},
        {title: '均日粮成本(元/天)',field: 'avgDayCost',},
        {title: '阶段总耗料(kg)',field: 'stageCostTotal',},
        {title: '阶段饲喂成本(元)',field: 'stageFeedCost',},
      ],
      productionResultsCell: [
        {title: '死淘率(%)',field: 'deadDisuseRatio',},
        {title: '料肉比(FCR)',field: 'weightCostRatio',},
        {title: '平均日增重(kg/头)',field: 'avgWeightIncrementDay',},
      ],
      economicBenefits: [
        {title: '造肉成本(元/kg)',field: 'mealProductCost',},
        {title: '毛收入(元/头/天)',field: 'netProfit',},
        {title: '总毛收入(元/头)',field: 'totalNetProfit',},
        {title: '本批毛收入(元)',field: 'currentNetProfit',},
      ],
    }
  },
  watch: {},
  computed: {
    feedDetail() {
      let obj = {...this.detail.ruminationLineFeedInfo}
      return obj
    },
    feedList() {
      let {intoDay,intoDayAge,avgInitialWeight,intoNum,outDay,outDayAge,avgEndWeight,outNum} = this.detail.ruminationLineFeedInfo || {}
      let feedList = [
        {state: '入栏',day: intoDay,dayAge: intoDayAge,weight: avgInitialWeight,num: intoNum},
        {state: '出栏',day: outDay,dayAge: outDayAge,weight: avgEndWeight,num: outNum},
      ]
      return feedList
    },
    ruminationLineRaiseInfos(){
      return this.detail.ruminationLineRaiseInfos || []
    },
    ruminationLineProductResult(){
      let {ruminationLineFeedInfo={},ruminationLineProductResult = {}} = this.detail || {}
      let obj = {...ruminationLineProductResult || {}}
      obj.totalWeight = ruminationLineFeedInfo.avgEndWeight - ruminationLineFeedInfo.avgInitialWeight
      return obj
    },
  },
  created() {},
  mounted() {},
  methods: {},
}
</script>
<style lang='scss'></style>
<style lang='scss' scoped>
.tableBox2{
  background-color: #fff;
  border-radius:5px;
  padding: 0 20px
}
</style>